export const proxy = 'https://minhdz.binhminh19112003.workers.dev';
// export const proxy = 'http://127.0.0.1:8787';
